import { CardTypeCallToActions, Learning_Type } from '@app/enums/_index';
import { Pipe, PipeTransform } from '@angular/core';
import {
  getEnrollmentStatus,
  isValidSubscription,
  isDigitalSubscriptionEnrolled,
} from '@app/utilities/_index';

import { User } from '@app/models/_index';
import { environment } from '@environments/environment';

@Pipe({
  name: 'courseDetailTypeCallToActions',
  pure: false,
  standalone: false,
})
export class CourseDetailTypeCallToActionsPipe implements PipeTransform {
  /**
   * Return transformed learning type string to new display call to action for unsigned
   * or user that is not logged in
   * @param user - If user is signed in, then the transformed type will return a different display type.
   * @param learningType - learning type to transform to new display type
   * @param subscriptionId - Subscription id used to check if the user has this subscription
   * @param relatedSubscriptionIds - Related subscriptions used to check if the course can appear in 1 to N subscriptions
   * @param courseId - Course id used to check if the use has this enrollment already to determine enrollment status
   * @param isFreeCourse - Is Free course if the course IsFreeCourse additional field from course is true, else false.
   * @returns - transformed call to action string
   */
  public transform(
    user: User,
    subscriptionId: number,
    learningType: string,
    relatedSubscriptionIds: number[],
    courseId: number,
    isFreeCourse: boolean
  ): string {
    switch (learningType) {
      case Learning_Type.SUBSCRIPTION:
        return CardTypeCallToActions.LEARN_MORE;
      case Learning_Type.SELF_STUDY:
      case Learning_Type.E_LEARNING:
      case Learning_Type.QUICK_LEARNING:
      case Learning_Type.WEBINAR:
        if (user) {
          if (user.activeSubscriptions && user.activeSubscriptions.length > 0) {
            // Check if user has active subscription id that matches incoming subscription id
            // NOTE: Check if user has active subscription ids (it can match 1 or N subscription) that matches incoming subscription id, example
            // is Predictive Engagement: Altocloud - eLearning, which is in available in 3 subscriptions.
            const isSubscribed = isValidSubscription(relatedSubscriptionIds, subscriptionId, user);
            return getEnrollmentStatus(user, courseId, isFreeCourse, isSubscribed, learningType);
          } else {
            return getEnrollmentStatus(user, courseId, isFreeCourse, false, learningType);
          }
        } else {
          return CardTypeCallToActions.LEARN_MORE;
        }
      case Learning_Type.CERTIFICATION_EXAM:
        if (user) {
          if (user && user.activeSubscriptions && user.activeSubscriptions.length > 0) {
            // Check if user has active subscription id that matches incoming subscription id
            const isSubscribed = isValidSubscription(relatedSubscriptionIds, subscriptionId, user);
            return getEnrollmentStatus(user, courseId, isFreeCourse, isSubscribed, learningType);
          } else {
            // Enable Enroll option for Certification Exam Genesys Cloud CX: Professional Certification and Genesys Cloud CX: Developer Certification if the user is enrolled to Genesys Cloud CX Partner Digital Learning or Genesys Cloud CX Partner Digital Plus Learning
            const isSubscribed = isDigitalSubscriptionEnrolled(courseId, user);
            return getEnrollmentStatus(user, courseId, isFreeCourse, isSubscribed, learningType);
          }
        } else {
          return CardTypeCallToActions.SIGN_IN;
        }
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.VIRTUAL:
      case Learning_Type.IN_PERSON:
        // NOTE: Show view enrollment options regardless if user is signed in or not.
        return CardTypeCallToActions.LEARN_MORE;
      default:
        return CardTypeCallToActions.LEARN_MORE;
    }
  }
}
